<div id="threejs-floor-preview">
  <!-- Three.js floor preview will be rendered here -->
</div>
@if (!isToolActive) {
<div id="arclive-session-options-bar" style="
    width: 100%;
    height: 53px;
    border-bottom: 1px solid #111;
    background: #30323B;
  " [ngStyle]="sessionStyle">
    <div class="logo-toggle-button">
      <img src="assets\img\images\illum-tezzeract.png" alt="ArcLiveLogo" class="session-bar-logo" height="45px" />
      @if (isToggleMenu) {
        <button id="drawer-control-button"
          class="cesium-button cesium-toolbar-button menu-outline-icon" type="button" ng-show="showDrawerIcon()"
          (click)="showHideDrawer()">
          @if (!drawerOpen) {
            <i class="fa fa-bars" aria-hidden="true"></i>
          }
          @if (drawerOpen) {
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          }
        </button>
      }
    </div>
    <div class="session-class">
      <div (click)="changeMode()" class="monitor-mode">
        <span style="cursor: pointer">
          @switch (sessionName) {
            @case ('Monitor Mode') {
              <i class="fa-solid fa-tv mode-class"></i>
            }
            @case ('Live Mode') {
              <i class="fa-solid fa-satellite-dish mode-class"></i>
            }
            @case ('Playback Mode') {
              <i class="fa-solid fa-repeat mode-class"></i>
            }
            @default {
              <i class="fa-solid fa-tv mode-class"></i>
            }
          }
        </span>
        <span style="color: #fff; font-weight: 600; font-size: 1.1rem">({{ sessionName }})</span>
      </div>
    </div>
    <div class="user-info-banner">
      <h4 style="display: inline">{{ sessionOrganization }}</h4>
    </div>
  </div>
}

<app-globe></app-globe>
@if (entities && entities.length > 0) {
  <app-over-lapping-entities [entities]="entities"
  [position]="position"></app-over-lapping-entities>
}
@if (entity && entity?.id && showBuildingCamera && !isAddSafeZone && !showFixedPerimeterCreator) {
  <app-building-camera [entity]="entity"
    [hideEventDetailsForLiveNotification]="cameraService.getHideEventDetailsForLiveNotification()"
  (close)="onCloseBuildingCamera()" (addSafeZoneStatus)="onSafeZoneStatusChanged($event)"></app-building-camera>
}
@if (!isToolActive) {
  <app-timelines-ui id="arcLiveTimeline"
  style="position: absolute; bottom: 0px;z-index: 3; width: 100%;"></app-timelines-ui>
}


@if (showOrgTreePanel) {
  <div class="left-menu">
    @if (!orgTree) {
      <div class="w-100 text-center">Loading Org Tree...</div>
    }
    @if (orgTree) {
      <div class="p-1">Filter <input type="text" [(ngModel)]="orgTreeSearch" /></div>
    }
    @if (orgTree) {
      <app-org-tree [orgTree]="orgTree" [search]="orgTreeSearch"
      (nodeSelectionChange)="onClickNode($event)" (orgTreeUpdated)="onOrgTreeUpdated()"></app-org-tree>
    }
  </div>
}
@if (isMonitorMode && !isToolActive) {
  <div class="main-tab" [ngStyle]="{ left: showOrgTreePanel ? '240px' : '0px', display: 'flex', flexDirection: 'row', height: '100vh' }">
    <div class=" ">
      @if (sessionName !== 'Live Mode') {
        <ul class="nav nav-tabs custom-tabs">
          <li [class.active]="showLive">
            <a data-toggle="tab" data-target="#live-menu-tab" (click)="setShowLive(true)">Live</a>
          </li>
          <li [class.active]="!showLive">
            <a data-toggle="tab" data-target="#orgs-menu-tab" (click)="setShowLive(false)">Organization</a>
          </li>
        </ul>
      }
      @if (showLive && sessionName !== 'Live Mode') {
        <div id="live-menu-tabs" class="tab-pane">
          <div class="row gap-2">
            <div id="navigation" class="col-lg-4 col-md-4 col-sm-5">
              @if (isMonitorMode) {
                <ul class="nav nav-pills nav-stacked">
                  <li [class.active]="isDataFeedListActive()" class="nav-item btn-xs" heading="Alerts">
                    <a (click)="selectDataFeedList()" class="nav-link nav-pill-btn">Alerts
                <span class="badge drawer-badge" [ngStyle]="{
                    'background-color': activeAlertsCount > 0 ? '#ee5b5b' : ''
                  }">
                        {{ activeAlertsCount }}
                      </span>
                    </a>
                  </li>
                  <li [class.active]="isIncidentsActive()" class="nav-item btn-xs" heading="Incidents">
                    <a (click)="selectIncidents()" class="nav-link nav-pill-btn">Incidents
                <span class="badge drawer-badge" [ngStyle]="{
                    'background-color': activeincidents > 0 ? '#ee5b5b' : ''
                  }">
                        {{ activeincidents }}
                      </span>
                    </a>
                  </li>
                  <!-- remove procalls section -->
                  <li [class.active]="isProcallsActive()" class="nav-item btn-xs d-none" heading="Procalls">
                    <a (click)="selectProcalls()" class="nav-link nav-pill-btn">Procalls
                <span class="badge drawer-badge" [ngStyle]="{
                    'background-color': openprocalls > 0 ? '#ee5b5b' : ''
                  }">
                        {{ openprocalls }}
                      </span>
                    </a>
                  </li>
                  <li [class.active]="isActiveTrackingActive()" class="nav-item btn-xs" heading="Tracking">
                    <a (click)="selectActiveTracking()" class="nav-link nav-pill-btn">Tracking
                <span class="badge drawer-badge" [ngStyle]="{
                    'background-color': opentracking > 0 ? '#ee5b5b' : ''
                  }">
                        {{ opentracking }}
                      </span>
                    </a>
                  </li>
                  <li [class.active]="isMessagingActive()" class="nav-item btn-xs" heading="Messaging">
                    <a (click)="selectMessaging()" class="nav-link nav-pill-btn">Messaging
                <span class="badge drawer-badge" [ngStyle]="{
                    'background-color':
                      getNumberOfNewMessages() > 0 ? '#ee5b5b' : ''
                  }">
                        {{ getNumberOfNewMessages() }}
                      </span>
                    </a>
                  </li>
                  @if (actions.twitter) {
                    <li class="nav-item btn-xs nav-pills-d-none" heading="Twitter">
                      <a (click)="openTwitterSearchUi()" class="nav-link nav-pill-btn">Twitter Search</a>
                    </li>
                  }
                  <li class="nav-item btn-xs nav-pills-d-none" heading="Flight">
                    <a (click)="openFlightTrackerUi()" class="nav-link nav-pill-btn">Flight Tracker</a>
                  </li>
                  <div style="margin-top: 20px; margin-left: 10px">
                    @if (isDemoUser) {
                      <div>
                        <li class="nav-item btn-xs">
                          <!-- [(ngModel)]="buildingscheckbox" -->
                          <input type="checkbox" [(ngModel)]="buildingscheckbox" (change)="showHideAllianzBuildings($event)" />
                          <span class="nav-link nav-pill-btn">Buildings</span>
                        </li>
                        <li class="nav-item btn-xs">
                          <!-- [(ngModel)]="earthquakecheckbox" -->
                          <input type="checkbox" [(ngModel)]="earthquakecheckbox" (change)="showHideEarthquake($event)" />
                          <span class="nav-link nav-pill-btn">Earthquake</span>
                        </li>
                        <li class="nav-item btn-xs">
                          <!-- [(ngModel)]="demo2checkbox"  -->
                          <input type="checkbox" [(ngModel)]="demo2checkbox" (change)="showHideDemo2($event)" />
                          <span class="nav-link nav-pill-btn">Demo 2</span>
                        </li>
                      </div>
                    }
                    <div>
                      <li class="nav-item btn-xs nav-pills-d-none">
                        <!-- [(ngModel)]="covidcheckbox"  -->
                        <input type="checkbox" [(ngModel)]="covidcheckbox" (change)="showHideCovid($event)" />
                        <span class="nav-link nav-pill-btn">COVID-19</span>
                      </li>
                    </div>
                  </div>
                </ul>
              }
            </div>
            @if (isMonitorMode) {
              <div id="main" class="col-lg-7 col-md-7 col-sm-6 pb-2">
                @if (selectedTab === 'alerts') {
                  <app-alert [notificationsList]="notificationsList" #alertList></app-alert>
                }
                @if (selectedTab === 'incidents') {
                  <app-incident (openPinDialog)="onOpenPinDialog($event)"
                  [incidentDetails]="incidentDetails" [geofenceResults]="geofenceResults"></app-incident>
                }
                @if (isProcallsActive() && selectedTab === 'procalls') {
                  <app-procalls-list></app-procalls-list>
                }
                @if (isActiveTrackingActive() && selectedTab === 'tracking') {
                  <app-active-tracking-list
                  ></app-active-tracking-list>
                }
                @if (selectedTab === 'messaging') {
                  <app-messages-list (openGeofenceCreator)="openGeofenceCreator()">
                  </app-messages-list>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (!showLive && sessionName !== 'Live Mode') {
        <div id="orgs-menu-tabs" class="tab-pane">
          <span>
            @if (!showOrgTreePanel) {
              <i class="fa fa-caret-right fa-1x" (click)="toggleOrgTreePanel()"
              style="cursor: pointer" title="show org tree"></i>
            }
            @if (showOrgTreePanel) {
              <i class="fa fa-caret-left fa-1x" (click)="toggleOrgTreePanel()"
              style="cursor: pointer" title="hide org tree"></i>
            }
          </span>
          <div class="row gap-1">
            <div id="navigation" class="col-lg-4 col-md-4 col-sm-5 pe-1 custom-scroll">
              <ul class="nav nav-pills nav-stacked list-word-wrap">
                <li [class.active]="isOrgActive()" class="nav-item btn-xs" heading="Organizations">
                  <a (click)="selectOrg()" class="nav-link nav-pill-btn">Organizations
                    <span class="badge drawer-badge">
                      {{ getNumberOfSelectedOrgs() }}
                    </span>
                  </a>
                </li>
                <li [class.active]="isUsersActive()" class="nav-item btn-xs" heading="Users">
                  <a (click)="selectUsers()" class="nav-link nav-pill-btn">
                    <div class="tab-center">
                      <span (click)="toggleUsers($event)" class="tab-eye">
                        <i [ngClass]="showUsers ? 'visible-item' : 'hidden-item'" title="Show/Hide"></i>
                      </span>
                      <span>
                        Users <span class="badge drawer-badge">{{ getNumberOfUsersFiltered() }}</span>
                      </span>
                    </div>
                  </a>
                </li>
                <li [class.active]="isBuildingsActive()" class="nav-item btn-xs" heading="Facilities">
                  <a (click)="selectBuildings()" class="nav-link nav-pill-btn">
                    <div class="tab-center">
                      <span (click)="toggleFacilities($event)" class="tab-eye">
                        <i [ngClass]="showFacilities ? 'visible-item' : 'hidden-item'" title="Show/Hide"></i>
                      </span>
                      <span>Facilities</span>
                    </div>
                  </a>
                </li>
                @if (hasCampusAdmin) {
                  <li [class.active]="isCampusActive()" class="nav-item btn-xs" heading="Campus">
                    <a (click)="selectCampus()" class="nav-link nav-pill-btn">
                      <span>Campuses</span>
                    </a>
                  </li>
                }
                @if (actions.genetec) {
                  <li [class.active]="isCamerasActive()" class="nav-item btn-xs" heading="Cameras">
                    <a (click)="selectCameras()" class="nav-link nav-pill-btn">Cameras</a>
                  </li>
                }
                @if (actions.geofenceAlerting) {
                  <li [class.active]="isGeofencesActive()" class="nav-item btn-xs"
                    heading="Geofences">
                    <a (click)="selectGeofences()" class="nav-link nav-pill-btn">Geofences</a>
                  </li>
                }
                @if (actions.calendar) {
                  <li [class.active]="isTravelersActive()" class="nav-item btn-xs"
                    heading="Travelers">
                    <a (click)="selectTravelers()" class="nav-link nav-pill-btn">Travelers</a>
                  </li>
                }
                @for (group of groupList; track group) {
                  <li class="nav-item btn-xs" [class.active]="isGroupActive(group)"
                    [attr.heading]="group.name">
                    <a (click)="selectGroup(group)" class="nav-link nav-pill-btn">
                      {{ group.name }}
                    </a>
                  </li>
                }
              </ul>
            </div>
            <div id="main" class="col-lg-7 col-md-7 col-sm-6 pb-2">
              @switch (true) {
                @case (isOrgActive()) {
                  <app-org-pane [organizations]="organizations" [users]="users"></app-org-pane>
                }
                @case (isUsersActive()) {
                  <app-users-list [users]="users"
                  [phoneNumbers]="phoneNumbers"></app-users-list>
                }
                @case (isBuildingsActive()) {
                  <app-facilities-list></app-facilities-list>
                }
                @case (isCampusActive()) {
                  <app-campus-list></app-campus-list>
                }
                @case (isCamerasActive()) {
                  <app-camera-list [cameras]="cameras"></app-camera-list>
                }
                @case (isGeofencesActive()) {
                  <app-geofences-list [geofences]="geofences" [users]="users"
                  [drawnPolygon]="drawnGeofencePolygon" (openGeofenceCreator)="openGeofenceCreator()"></app-geofences-list>
                }
                @case (isTravelersActive()) {
                  <app-travelers-list></app-travelers-list>
                }
                @case (showGroupPanel()) {
                  <app-group-list></app-group-list>
                }
              }
            </div>
          </div>
        </div>
      }
      @if (sessionName === 'Live Mode') {
<div style="
        display: inline-block;
        width: 400px;
        vertical-align: top;
        margin: 0px;
      ">
          <div style="position: absolute1; width: 100%" id="orgs-menu-tab" class="tab-pane">
            <div class="row">
              <div id="navigation" class="col-lg-3 col-md-3 col-sm-3" style="padding-top: 5px">
                <ul class="nav nav-pills nav-stacked" style="padding-right: 1px !important">
                  <li ng-show="actions.genetec" ng-class="{ active: isCamerasActive() }" class="nav-item btn-xs"
                    heading="Cameras">
                    <a (click)="selectCameras()" class="nav-link nav-pill-btn">
                      <div>
                        <div style="display: inline-block">Cameras</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
          <div id="main" class="col-lg-9 col-md-9 col-sm-9" style="
              height: 100%;
              margin-right: 0px !important;
              padding-left: 30px !important;
            ">
                @switch (true) {
                  @case (isCamerasActive()) {
                    <app-camera-list [cameras]="cameras"></app-camera-list>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Update wrench action drawer with all state handling -->
<app-wrench-action-drawer (toolState)="onToolStateChange($event)" [sessionName]="sessionName">
</app-wrench-action-drawer>
@if (showFixedPerimeterCreator) {
  <app-fixed-perimeter-creator-button [creationId]="fixedPerimeterCreationId!"
    (close)="onCloseFixedPerimeterCreator()" (openPinDialog)="onOpenPinDialog($event)">
  </app-fixed-perimeter-creator-button>
}
@if (showGeofenceCreator) {
  <app-geofence-creation-button (done)="onGeofenceCreationDone($event)"
  (cancel)="onGeofenceCreationCancel()"></app-geofence-creation-button>
}

@if (adhocMessageWindowVisible) {
  <app-ad-hoc-message-window (openGeofenceCreator)="openGeofenceCreator()"
  [locations]="drawnGeofencePolygon"></app-ad-hoc-message-window>
}
@if (isAddSafeZone) {
  <app-safezone-creator [eventId]="safeZoneEventId!"
  (addSafeZoneStatus)="onSafeZoneStatusChanged($event)"></app-safezone-creator>
}
@if (selectedBuilding) {
  <div>
    <app-building-info
      [data]="selectedBuilding"
      [screenX]="popupX"
      [screenY]="popupY"
    ></app-building-info>
  </div>
}
